import React from 'react';
export const Header = () => {
  return <header className="w-full bg-white text-white" data-id="element-64">
      <div className="w-full bg-amber-400" data-id="element-65">
        <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-66">
          <div className="flex justify-center items-center h-16" data-id="element-67">
            <div className="text-black text-[19px] font-semibold tracking-wide flex items-center justify-center w-full" data-id="element-68">
              <span className="mr-2" data-id="element-69">🔥</span>
              Back in Stock – Limited Quantities Available
            </div>
          </div>
        </div>
      </div>
      <div className="w-full bg-white mt-2" data-id="element-70">
        <div className="max-w-6xl mx-auto px-4 md:px-8 pt-16 md:pt-24 flex flex-col md:flex-row items-center" data-id="element-71">
          <div className="md:w-1/2 mb-8 md:mb-0" data-id="element-72">
            <div className="text-8xl font-bold text-[#0c2021]" data-id="element-73">5</div>
            <h1 className="text-3xl md:text-4xl font-bold text-[#0c2021] leading-tight mt-2" data-id="element-74">
              Reasons Zenora Keeps Selling Out
              <br data-id="element-75" />
              <span className="text-xl md:text-2xl" data-id="element-76">
                (And Why Everyone Wants One)
              </span>
            </h1>
            <p className="text-gray-700 mt-6 text-[19px]" data-id="element-77">
              Demand for Zenora has exploded, selling out in just days. If
              you're wondering why so many people are choosing it over other
              trackers, here are the 5 big reasons users keep coming back.
            </p>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-78">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ijXiwpYszNZgaFnuiSX3sT/Untitled_design_%2812%29.jpg" alt="Zenora Smart Ring" className="rounded-lg shadow-xl w-full max-w-md" data-id="element-79" />
          </div>
        </div>
      </div>
    </header>;
};